export const FETCH_CONNECTORS = 'FETCH_CONNECTORS';
export const FETCH_CONNECTORS_SUCCESS = 'FETCH_CONNECTORS_SUCCESS';
export const FETCH_CONNECTORS_ERROR = 'FETCH_CONNECTORS_ERROR';

export const fetchConnectors = () => ({ type: FETCH_CONNECTORS });
